import { KeepCheckbox, SectionNameCell } from "./HeadingSyncModalComponents";
import { getDepth } from "./HeadingSyncModalHierarchy";

const REMOVE_ANNOTATION = "(Remove)";
const KEEP_ANNOTATION = "(Keep)";

export const buildDeleteRows = (deletions = []) =>
  deletions.map((item) => ({
    id: `del-${item.outlineItemId}`,
    outlineItemId: item.outlineItemId,
    parentId: item.parentId ?? null,
    title: item.title,
  }));

export const buildSyncRows = ({
  titleChanges = [],
  levelChanges = [],
  additions = [],
  deletions = [],
} = {}) => [
  ...titleChanges.map((change) => ({
    id: `rn-${change.outlineItemId}`,
    outlineItemId: change.outlineItemId,
    parentId: change.parentId ?? null,
    title: change.currentTitle,
    annotation: `(Renamed from "${change.originalTitle}")`,
  })),
  ...levelChanges.map((change) => ({
    id: `lv-${change.outlineItemId}`,
    outlineItemId: change.outlineItemId,
    parentId: change.parentId ?? null,
    title: change.title,
    annotation: `(H${change.originalLevel} → H${change.currentLevel})`,
  })),
  ...additions.map((item, i) => ({
    id: `add-${i}`,
    outlineItemId: null,
    parentId: null,
    title: item.title,
    annotation: `(Added, H${item.headingLevel})`,
  })),
  ...deletions.map((item) => ({
    id: `del-${item.outlineItemId}`,
    outlineItemId: item.outlineItemId,
    parentId: item.parentId ?? null,
    title: item.title,
    annotation: "(Removed)",
  })),
];

export const buildSyncColumns = ({ parentOf = new Map() } = {}) => [
  {
    header: "Section Name",
    id: "sectionName",
    accessorKey: "title",
    enableSorting: false,
    enableResizing: false,
    meta: {
      flexGrow: 1,
    },
    cell: ({ row }) => (
      <SectionNameCell
        title={row.original.title}
        annotation={row.original.annotation}
        depth={getDepth(row.original.outlineItemId, parentOf)}
      />
    ),
  },
];

export const buildDeleteColumns = ({
  keptIds,
  onToggle,
  parentOf,
  isEnabled,
}) => [
  {
    header: "Section Name",
    id: "sectionName",
    accessorKey: "title",
    size: 300,
    meta: {
      flexGrow: 1,
    },
    enableSorting: false,
    cell: ({ row }) => {
      const isKept = keptIds.has(row.original.outlineItemId);
      return (
        <SectionNameCell
          title={row.original.title}
          annotation={isKept ? KEEP_ANNOTATION : REMOVE_ANNOTATION}
          strikethrough={!isKept}
          reserveAnnotationWidth
          depth={getDepth(row.original.outlineItemId, parentOf)}
        />
      );
    },
  },
  {
    header: "Keep",
    id: "keep",
    size: 80,
    meta: { flexGrow: 0 },
    enableSorting: false,
    enableResizing: false,
    pin: "right",
    cell: ({ row }) => {
      const { outlineItemId } = row.original;
      return (
        <KeepCheckbox
          title={row.original.title}
          isKept={keptIds.has(outlineItemId)}
          onToggle={() => onToggle(outlineItemId)}
          disabled={!isEnabled(outlineItemId)}
        />
      );
    },
  },
];
